import { createContext, useContext } from "react";
import { DealsGridContext, CompleteJson } from "../types/DealTracker";

type TradeFlowTrackerContextType = {
  isOpen: boolean;
  toggle: () => void;
  activeTab: number;
  setActiveTab: (i: number) => void;
  rowData: CompleteJson;
  tableContext: DealsGridContext;
  isViewer: boolean;
  openTradeFlowTracker: () => void;
};

export const TradeFlowTrackerContext =
  createContext<TradeFlowTrackerContextType | null>(null);

export const useTradeFlowTracker = () => {
  const ctx = useContext(TradeFlowTrackerContext);
  if (!ctx) {
    throw new Error(
      "TradeFlowTracker components must be used within TradeFlowTracker"
    );
  }
  return ctx;
};
